export default "__VITE_ASSET__BcB1Z2NR__"